// DBMS manifest 보관 reducer.
// backend `/sql-developer/dbtypes` 응답 (각 어댑터의 manifest 배열) 을 redux 에 저장.
// UI 가 capability flag 로 메뉴/버튼을 가지치기할 수 있도록 단일 진실 소스 제공.

const DBMS_MANIFESTS_SET = 'DBMS_MANIFESTS_SET';
const DBMS_MANIFESTS_ERROR = 'DBMS_MANIFESTS_ERROR';

const initialState = {
    list: [],
    byType: {},
    loaded: false,
    error: null,
};

const dbmsReducer = (state = initialState, action) => {
    switch (action.type) {
        case DBMS_MANIFESTS_SET: {
            const list = Array.isArray(action.payload) ? action.payload : [];
            const byType = {};
            for (const m of list) {
                if (m && m.dbType) byType[m.dbType] = m;
            }
            return { ...state, list, byType, loaded: true, error: null };
        }
        case DBMS_MANIFESTS_ERROR:
            return { ...state, error: action.payload || 'unknown error' };
        default:
            return state;
    }
};

export default dbmsReducer;
export { DBMS_MANIFESTS_SET, DBMS_MANIFESTS_ERROR };
